/** @module route
 *  @description 路由类型模块
 */
import { common } from './common';
import { user } from './user';
import { play } from './play';
import { setting } from './setting';

/** @ignore */
export const route = {
  ...common,
  ...user,
  ...play,
  ...setting,
};
